import type { Property } from 'csstype';

export default function SmallVerticalTabLine({horizontalPadding, colour}: {horizontalPadding: number; colour: Property.Color}) {
    return (
        <div className="vertical-tab-line" style={{ padding: horizontalPadding, display: 'flex', flexDirection: 'column',  alignSelf: 'stretch'}}>
            <div style={{ flex: 4 }} />
            <div style={{ flex: 1, width: 1.2, backgroundColor: colour}} />
            <div style={{ flex: 4 }} />
        </div>
    )
}